import { createReducer, on } from '@ngrx/store';
import {
  deleteUsers,
  getUsers,
  sentUsers,
  saveUsers,
  updateUsers,
  setUsers,
  sentDeleteUsers,
  getUsersBasedOnSearch,
  setSidBasedUsers,
  setAppForUsers,
  getSidBasedUsers,
  getErrorMessage,
  setUsersForSearch
} from '../actions/users.actions';

export interface UsersState {
  data: any;
  loader: boolean;
  sidUserData: any;
  searchText: any;
}

export const initialState: UsersState = {
  data: [],
  loader: true,
  sidUserData: {},
  searchText: ''
};

export const usersReducer = createReducer(
  initialState,
  on(getUsers, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants,
    sidUserData: {},
    searchText: '',
    loader: true
  })),
  on(setUsers, (state, { usersData, totalRecords }) => {
    return {
      ...state,
      data: { usersData, totalRecords },
      sidUserData: {},
      loader: false
    };
  }),
  on(setUsersForSearch, (state, { usersData, totalRecords }) => {
    return {
      ...state,
      searchData: { usersData, totalRecords },
      sidUserData: {},
      loader: false
    };
  }),
  on(sentUsers, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(saveUsers, (state, { saveUsersData }) => {
    const allData: any[] = state.data.length > 0 ? [...state.data, saveUsersData] : [saveUsersData];
    return {
      ...state,
      data: allData,
      sidUserData: {},
      loader: false
    };
  }),
  on(updateUsers, (state, { updateUsersData }) => {
    let allData: any[] = [];
    if (state.data.usersData.length) {
      const toBeFilteredData = [...state.data.usersData];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData.findIndex((app) => app.sid === updateUsersData.sid);

      if (updateIndex === -1) {
        allData.unshift(updateUsersData);
      } else {
        allData[updateIndex] = updateUsersData;
      }
      // allData = toBeFilteredData.filter(
      //   (user) => user.sid !== updateUsersData.sid
      // );
      // allData.push(updateUsersData);
    } else {
      allData = [updateUsersData];
    }
    return {
      ...state,
      data: { usersData: allData, totalRecords: allData.length },
      sidUserData: {},
      loader: false
    };
  }),
  on(sentDeleteUsers, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(deleteUsers, (state, { usersId }) => {
    const allUsersData = state.data.usersData;
    const filteredData = allUsersData.filter((user: { sid: string }) => user.sid !== usersId);

    return {
      ...state,
      data: { usersData: filteredData, totalRecords: filteredData.length },
      loader: false
    };
  }),
  on(getSidBasedUsers, (state) => {
    return {
      ...state,
      loader: true,
      sidUserData: {}
    };
  }),
  on(setSidBasedUsers, (state, { sidUserData }) => {
    const parsedData = sidUserData.attachments ? JSON.parse(sidUserData.attachments) : '';
    const savedDocument = { ...sidUserData, parsedDocs: [...parsedData] };

    return {
      ...state,
      loader: false,
      sidUserData: savedDocument
    };
  }),
  on(setAppForUsers, (state, { sidAppData }) => {
    return {
      ...state,
      loader: false,
      sidAppData: sidAppData
    };
  }),
  on(getUsersBasedOnSearch, (state, { searchFields }) => {
    return {
      ...state,
      searchFields,
      loader: true
    };
  }),
  on(getErrorMessage, (state, errorMessage) => {
    return {
      ...state,
      errorMessage,
      loader: false
    };
  })
);
